import React, { useState } from "react";
import { Container } from "react-bootstrap";
import WpImageFluid from "../components/WpImageFluid";
import ArrowIcon from "../icons/arrow-16.svg";
import { VectorBackground } from "../components/VectorBackground";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ContainerWide from "../components/ContainerWide";
import HubspotFormModal from "../components/HubspotFormModal";

import "swiper/css";
import "swiper/css/navigation";

const ClientCases = ({ category, header, cases, slug }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeDownload, setActiveDownload] = useState(null);
    const [modalSessionId, setModalSessionId] = useState(0);

    if (!cases || cases.length === 0) return null;

    const handleLinkClick = (event, clientCase) => {
        event.preventDefault();
        event.stopPropagation();
        event.nativeEvent?.stopImmediatePropagation?.();

        setActiveDownload({
            url: clientCase.link.url,
            header: clientCase.link.title || "Download Our Client Case",
            description: clientCase.description,
        });
        setModalSessionId((sessionId) => sessionId + 1);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setActiveDownload(null);
    };

    return (
        <section className="client-cases" id={slug || "client-cases"}>
            <ContainerWide>
                <div className="client-cases__container">
                    <VectorBackground gradient />
                    <Container className="client-cases__content-container">
                        {category && (
                            <p
                                className="client-cases__label"
                                dangerouslySetInnerHTML={{ __html: category }}
                            />
                        )}
                        {header && (
                            <h2
                                className="client-cases__header"
                                dangerouslySetInnerHTML={{ __html: header }}
                            />
                        )}

                        <div className="client-cases__slider-wrapper">
                            <Swiper
                                modules={[Navigation]}
                                navigation={{
                                    prevEl: ".client-cases__nav-prev",
                                    nextEl: ".client-cases__nav-next",
                                }}
                                spaceBetween={30}
                                slidesPerView={1}
                                loop={true}
                            >
                                {cases.map((clientCase, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="client-cases__card">
                                            <div className="client-cases__content">
                                                {clientCase.category && (
                                                    <h3
                                                        className="client-cases__category"
                                                        dangerouslySetInnerHTML={{
                                                            __html: clientCase.category,
                                                        }}
                                                    />
                                                )}
                                                {clientCase.description && (
                                                    <div
                                                        className="client-cases__description"
                                                        dangerouslySetInnerHTML={{
                                                            __html: clientCase.description,
                                                        }}
                                                    />
                                                )}
                                                {clientCase.link &&
                                                    clientCase.link.url && (
                                                        <button
                                                            type="button"
                                                            className="client-cases__link"
                                                            onClickCapture={(
                                                                event
                                                            ) =>
                                                                handleLinkClick(
                                                                    event,
                                                                    clientCase
                                                                )
                                                            }
                                                        >
                                                            {clientCase.link
                                                                .title ||
                                                                "Download Our Client Case"}
                                                            <ArrowIcon className="client-cases__link-arrow" />
                                                        </button>
                                                    )}
                                            </div>
                                            <div className="client-cases__image">
                                                {clientCase.image ? (
                                                    <WpImageFluid
                                                        image={clientCase.image}
                                                        alt={
                                                            clientCase.category ||
                                                            ""
                                                        }
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                        <div className="client-cases__nav">
                            <button
                                className="client-cases__nav-prev"
                                aria-label="Previous"
                            >
                                <ArrowIcon className="arrow-prev" />
                            </button>
                            <button
                                className="client-cases__nav-next"
                                aria-label="Next"
                            >
                                <ArrowIcon className="arrow-next" />
                            </button>
                        </div>
                    </Container>
                </div>
            </ContainerWide>
            <HubspotFormModal
                key={modalSessionId}
                isOpen={isModalOpen}
                onClose={handleModalClose}
                pageTitle={activeDownload?.header || "Download Our Client Case"}
                header={activeDownload?.header}
                description={activeDownload?.description}
                pdfUrl={activeDownload?.url}
            />
        </section>
    );
};

export default ClientCases;
